import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gifs/Aguarde.gif'


const _withScopeId = n => (_pushScopeId("data-v-7a29d45d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-page" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "col-sm-6 col-md-6 mx-2 profissional" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "form-label mb-0 pe-2 marginBotoes d-flex flex-column",
  for: "dataAgenda"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-calendar-date",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "currentColor",
  class: "bi bi-person-bounding-box me-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" })
], -1))
const _hoisted_11 = { class: "form-label col-12" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "d-flex flex-row justify-content-center" }
const _hoisted_15 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "d-flex flex-row-reverse botoes" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex flex-row justify-content-center"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  fill: "currentColor",
  class: "bi bi-calendar-date",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, " Agendamento ", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "d-flex flex-row justify-content-center mb-3"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  fill: "currentColor",
  class: "bi bi-calendar-date",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, " Atendimento ", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "d-flex flex-row justify-content-evenly mt-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  fill: "currentColor",
  class: "bi bi-clipboard",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, " Prontuário ", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  fill: "currentColor",
  class: "bi bi-clipboard-data",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" })
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, " Histórico ", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imagem" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "imagemTamanho",
    src: _imports_0,
    alt: ""
  })
], -1))

import ModalPesqDorape from '@/components/ModalPesqDorape.vue';
import { onMounted, reactive, ref, capitalize } from 'vue';
import AgendaProfissional from '@/model/AgendaProfissional';
import Atendimento from '@/components/Atendimento.vue';
import ModalDorape from '@/components/ModalDorape.vue';
import GridDorape from '@/components/GridDorape.vue';
import Especialidade from '@/model/Especialidade';
import Procedimento from '@/model/Procedimento';
import Profissional from '@/model/Profissional';
import { TipoMensagem } from '@/consts/consts';
import { computed } from '@vue/reactivity';
import mensagem from '@/hooks/mensagem';
import Paciente from '@/model/Paciente';
import Convenio from '@/model/Convenio';
import { store } from '@/store/index';
import Cidade from '@/model/Cidade';
import services from '@/services';
import moment from 'moment';
import ProntuarioComp from '@/components/ProntuarioComp.vue';
import PacienteProntuario from '@/model/PacienteProntuario';
import router from '@/router';
import configuracoes from '@/config/config.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'Agenda',
  props: ['maiusculo', 'retornaPossuiPermissao', 'retornaDataBR', 'retornaIdVDatePicker', 'retornaDataUSA', 'tema'],
  setup(__props) {

const props = __props;

let disabledDates = ref([
    {
        repeat: {
            weekdays: [1, 2, 3, 4, 5, 6, 7],
        },
    }
]);

let atributos = [
    //     dates: Array<Date>(), // new Date(2024, 3, 20),
    {
        bar: 'white',
        dates: Array<Date>()
    },
    {
        bar: 'white',
        dates: {
            repeat: {
                weekdays: []
            }
        }
    }
];



const config = computed(() => {
    return store.getters.getConfig;
});

const usuario = computed(() => {
    return store.getters.getUsuario;
});

const profissional = computed(() => {
    return store.getters.getProfissional;
});

const state = reactive({
    colunas: Array<string>('Hora', 'Paciente', 'Convênio', 'Resumo', 'Sala'),
    linhas: Array<string>('hora', 'nomePaciente', 'nomeConvenio', 'procedimento', 'sala'),
    lstAgendaPacienteCadastrado: Array<boolean>(),
    lstAgendaProf: Array<AgendaProfissional>(),
    lstProcedimentoAdd: Array<Procedimento>(),
    lstProcedimentoMostrar: Array<Procedimento>(),
    lstQtde: Array<number>(),
    lstQtdeAdd: Array<number>(),
    lstDias: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    lstDiasDisponiveis: Array<number>(),
    lstDiasAux: Array<number>(0, 1, 2, 3, 4, 5, 6, 0, 1, 2, 3, 4, 5, 6),
    lstProntuario: Array<PacienteProntuario>(),
    lstAgendaSala: Array<any>(),

    objetoAuxiliar: {
        id: 0,
        ativo: true,
        dtInclusao: String(),
        dtAlteracao: String(),
        usuario: "master",
        usuarioUpdate: String(),
        nome: "PROFISSIONAL TESTE",
        sigla: "CRM",
        numero: "000",
        uf: "ES",
        cbos: "3010",
        idCliente: "2",
    },
    profissional: Object() as Profissional,
    agenda: {
        agendado: Boolean(),
        dia: String(),
        hora: String(),
        idAgenda: Number(),
        item: Number(),
        nomeConvenio: String(),
        nomePaciente: String(),
        nomeProfissional: String(),
        pacienteCelular: String(),
        status: String(),
        statusDescricao: String(),
    },
    agendaLancar: {
        id: Number(),
        dtInclusao: new Date(),
        dtAgenda: new Date(),
        hrInclusao: new Date().toLocaleTimeString(),
        hrAgenda: String(),
        hrChegada: null,
        usuario: String(),
        usuarioUpdate: String(),
        status: String(),
        convenio: null || Convenio,
        profissional: null || Profissional,
        paciente: null || Paciente,
        idResumo: Number(),
        idAgendaPrincipal: Number(),
        idAtendimento: Number(),
        ordemChegada: Number(),
        whatsConfirmacao: String(),
        nomePaciente: null || String(),
        celular: null || String(),
        telefone: null || String(),
        idCliente: null || Number(),
        statusDescricao: null || String(),
        idPaciente: null || Number()
    },
    atendimento: {
        id: Number(),
        dtInclusao: new Date(),
        dtAlteracao: new Date(),
        hora: String(),
        idAgendamento: Number(),
        dtAgenda: new Date(),
        paciente: Paciente,
        convenio: Convenio,
        posicaoAtend: String(),
        usuario: String(),
        usuarioUpdate: String(),
        usuarioCancelamento: String(),
        revisao: "N" || String(),
        retorno24h: "N" || String(),
        valorPagMedico: Number(),
        valorPendencia: Number(),
        statusPendencia: "LB" || String(),
        idProfExec: Number(),
        idProfSolic: Number() || null,
        idTipoAtend: null,
        urgencia: Boolean(),
        total: Number(),
        desconto: Number(),
        tipoDesconto: "P" || String(),
        totalAcrescDesc: Number(),
        idCliente: Number()
    },
    atendProcedimento: {
        idAtendimento: Number(),
        item: Number(),
        horaInicial: null,
        horaFinal: null,
        idProcedimento: Number(),
        idConvenio: Number(),
        idFaturamento: null,
        idProfExec: Number(),
        qtde: Number(),
        vlrUnit: Number(),
        filme: null,
        imposto: null,
        valorProf: null,
        subTotal: Number(),
        idCliente: Number(),
    },
    procedimentoExcluir: Object(),
    cidade: Object() as Cidade,
    paciente: Object() as Paciente,
    convenio: Object() as Convenio,
    procedimento: Object() as Procedimento,
    especialidade: Object() as Especialidade,
    prontuario: Object() as PacienteProntuario,

    ativarPesquisaProf: Boolean(false),
    ativarPesquisaPac: Boolean(false),
    mostrarAtendimento: Boolean(false),
    agendando: Boolean(false),
    pacienteCadastrado: Boolean(true),
    exibicao: Boolean(true),
    ativarPesquisaConvenio: Boolean(),
    ativarPesquisaProcedimento: Boolean(),
    comConvenio: Boolean(),
    aguarde: Boolean(),
    atendGerado: Boolean(),
    telaCelular: Boolean(true),
    telaPequena: Boolean(true),
    mostrarConfirma: Boolean(),
    filtrarExcluirProcedimento: Boolean(),
    nomeSocial: Boolean(),
    modalProfissionalVisivel: Boolean(),
    prontuarioVisivel: Boolean(),
    mostrarOpcoes: Boolean(),
    historico: Boolean(),
    tema: Boolean(),
    showCalendar: Boolean(),

    diaAgenda: new Date(),
    diaAgendaComponente: new Date(),
    convenioDesc: String(),
    estadoAgenda: String(),
    especialidadeDesc: String(),
    nomePaciente: String(),
    profissionalDesc: String(),
    profAgenda: String(),
    confimarcaoCelular: String(),
    textoConfirma: String(),
    larguraMaxima: "70%",

    tabelaConvenio: Number(),
    progressWidth: Number(),
    somaQtde: Number(),
    valorFinal: Number(),
    alturaModalPesq: Number(),
    tamanhoLista: Number(),
});

function pesquisaVisivelProfissional() {
    state.ativarPesquisaProf = true;
}

async function diasDisponiveis(pId: number) {
    let sql = `SELECT PA.DIA FROM PROFISSIONAL_AGENDA PA
                                WHERE PA.ID_PROFISSIONAL = ${pId} and PA.TEMPO > 0 ORDER BY PA.DIA`;
    const { data, erros } = await services.relatorio.ListarSql(sql);
    if (!erros) {
        let dataAux = [1, 2, 3, 4, 5, 6, 7];
        // data.forEach((d: number) => {
        //     if (dataAux.includes(d)) {
        //         state.lstDiasDisponiveis.push(d);
        //         dataAux.splice(dataAux.indexOf(d), 1);
        //     }
        // });

        let sqlExtra = `SELECT PAE.DATA FROM PROFISSIONAL_AGENDA_EXTRA PAE 
            JOIN PROFISSIONAL_AGENDA_EXTRA_ITEM PAEI ON PAEI.ID_AGENDA = PAE.ID 
            WHERE PAEI.TEMPO > 0 AND PAE.ID_PROFISSIONAL = ${pId} ORDER BY PAE.DATA`;

        let dataExtra = await services.relatorio.ListarSql(sqlExtra);

        let diasExtras = Array<Date>();

        if (!dataExtra.erros) {
            dataExtra.data.forEach((de: string, i: number) => {
                // diasExtras.push(String(moment(new Date(de)).format("MM-DD-YYYY")));
                diasExtras.push(new Date(de));
            });
        }
        disabledDates.value[0].repeat.weekdays = dataAux;
        atributos[0].dates = diasExtras;
        //@ts-expect-error: un
        atributos[1].dates.repeat.weekdays = data;
    } else {
        const msg = mensagem();
        msg.InserirMensagem('Erro', erros.statusText, TipoMensagem.Error);
    }
}

async function modalPesqResultProf(result: string, obj: Profissional) {
    if (result == "ok") {
        state.profissionalDesc = obj.nome;
        state.profissional = obj;

        diasDisponiveis(obj.id);
    }
    state.ativarPesquisaProf = false;
}

async function verificarProximoDiaAgenda() {
    // console.log(state.lstDiasDisponiveis);
    // console.log(new Date().getDay());
    if (!state.lstDiasDisponiveis.includes(state.diaAgendaComponente.getDay())) {
        // console.log(state.diaAgendaComponente.getDay());
        // console.log(state.lstDiasAux.lastIndexOf(state.diaAgendaComponente.getDay()));
        // console.log(state.lstDiasAux.lastIndexOf(state.diaAgendaComponente.getDay()) - state.diaAgendaComponente.getDay() - 1);
        let aux = state.lstDiasAux.lastIndexOf(state.diaAgendaComponente.getDay()) - state.diaAgendaComponente.getDay() - 1;
        // console.log(new Date(`06/${state.lstDiasAux.lastIndexOf(state.diaAgendaComponente.getDay()) - state.diaAgendaComponente.getDay() - 1}/2023`));
        // console.log(`${state.diaAgendaComponente.getMonth() + 1}/${state.diaAgendaComponente.getDate() + aux}/${state.diaAgendaComponente.getFullYear()}`);
        if (String(new Date(`${state.diaAgendaComponente.getMonth() + 1}/${state.diaAgendaComponente.getDate() + aux}/${state.diaAgendaComponente.getFullYear()}`)) === "Invalid Date") {
            state.diaAgendaComponente = new Date(`${aux}/${state.diaAgendaComponente.getMonth() + 1}/${state.diaAgendaComponente.getFullYear()}`);
            //@ts-expect-error: un
            state.diaAgenda = moment(new Date(`${aux}/${state.diaAgendaComponente.getMonth() + 1}/${state.diaAgendaComponente.getFullYear()}`)).format("YYYY-MM-DD");
        }
        // console.log('não');
    } else {
        // console.log(state.lstDiasDisponiveis);
        // console.log('sim');
    }
}

async function gerar() {
    const inicio = performance.now();
    state.modalProfissionalVisivel = false;
    const msg = mensagem();
    var dia;
    // if (window.innerWidth >= 1024) {
    //     dia = new Date(state.diaAgenda);
    //     state.diaAgendaComponente = new Date(moment(dia).format(`MM-${dia.getDate() + 1}-YYYY`));
    // } else {
    dia = new Date(state.diaAgendaComponente);
    //@ts-expect-error:un
    state.diaAgenda = moment(new Date(state.diaAgendaComponente)).format("YYYY-MM-DD");
    // }
    var diaSemana = dia.getUTCDay();
    if (state.lstAgendaProf.length >= 1) {
        while (state.lstAgendaProf.length >= 1) {
            state.lstAgendaProf.shift();
        }
    }
    // state.lstAgendaProf = [];
    state.aguarde = true;
    if (state.profissional.id > 0) { // + 1
        let { data } = await services.agenda.ProfissionalAgendaExiste(state.profissional.id, diaSemana + 1);
        if (data == false) {
            let sql = `SELECT * FROM PROFISSIONAL_AGENDA_EXTRA PAE WHERE 
            PAE.ID_PROFISSIONAL = ${state.profissional.id}  AND PAE.DATA = '${moment(state.diaAgendaComponente).format("DD.MM.YYYY")}'`;
            data = await services.relatorio.ListarSql(sql);
            console.log(data);
        }
        if (data) {
            let data;
            let dataAgenda = await services.profissional.ProfissionalAgendaListar(state.profissional.id, diaSemana + 1);
            // console.log(dataAgenda);
            // (window.innerWidth >= 1024) ?
            //     data = await services.agenda.Listar(state.profissional.id, moment(state.diaAgenda).format("DD/MM/YYYY"))
            //     :
            data = await services.agenda.Listar(state.profissional.id, moment(state.diaAgendaComponente).format("DD/MM/YYYY"));
            // console.log(data.data);

            if (!dataAgenda.erros) {
                // let hora = new Date();
                // state.lstAgendaProf = [];
                // hora.setHours(dataAgenda.data[0].horaInicio.split(":")[0]);
                // hora.setMinutes(dataAgenda.data[0].horaInicio.split(":")[1]);
                // hora.setSeconds(dataAgenda.data[0].horaInicio.split(":")[2]);
                // console.log(data.data);
                // while (`${hora.getHours()}:${hora.getMinutes()}:${hora.getSeconds()}` < dataAgenda.data[0].horaFim) {

                //     // state.lstAgendaProf.push()


                //     hora.setMinutes(hora.getMinutes() + dataAgenda.data[0].tempo);
                // }

                // dataAgenda.data.forEach((d: any) => {
                //     console.log(d);
                // });
            }

            if (!data.erros) {
                if (data.data.length > 0) {
                    state.tamanhoLista = data.data.length;
                    state.lstAgendaProf = data.data;
                    // console.log(data.data);
                    // for (let i = 0; i < data.data.length; i++) {
                    //     let obj = Object() as any;
                    //     obj = data.data[i];
                    //     let aux = await services.agendaProcedimento.ListarPorId(data.data[i].idAgenda);
                    //     // console.log(aux);
                    //     if (!aux.erros) {
                    //         obj.nomeProcedimento = aux.data[0]?.procedimento?.descricao;
                    //     }
                    //     // if (configuracoes.mostrarSala) {
                    //     //     aux = await services.agenda.ListarPorId(data.data[i].idAgenda);
                    //     //     if (!aux.erros) {
                    //     //         if (aux.data) {
                    //     //             obj.sala = aux.data?.sala?.descricao;
                    //     //         }
                    //     //     }
                    //     // }
                    //     state.lstAgendaProf.push(obj);
                    // }
                }
            }
        } else {
            let sql = `SELECT FIRST 10 PA.DIA FROM PROFISSIONAL_AGENDA PA
                                        WHERE PA.ID_PROFISSIONAL = ${state.profissional.id} ORDER BY PA.DIA`;
            const { data, erros } = await services.relatorio.ListarSql(sql);
            if (!erros) {
                let dias = "";
                data.forEach((d: number, i: number) => {
                    switch (d) {
                        case 1:
                            dias += " Domingo";
                            break;
                        case 2:
                            dias += " Segunda";
                            break;
                        case 3:
                            dias += " Terça";
                            break;
                        case 4:
                            dias += " Quarta";
                            break;
                        case 5:
                            dias += " Quinta";
                            break;
                        case 6:
                            dias += " Sexta";
                            break;
                        case 7:
                            dias += " Sábado";
                            break;
                    }
                    if (data.length - 1 != i) {
                        dias += ",";
                    }
                });
                if (dias) {
                    state.profissionalDesc === "" ? msg.InserirMensagem('Atenção', "Insira um profissional", TipoMensagem.Alert)
                        : msg.InserirMensagem('Erro', `O profissional não possui horário marcado para este dia. O profissional atende${dias}`, TipoMensagem.Error);
                } else {
                    msg.InserirMensagem('Erro', `O profissional não possui agenda`, TipoMensagem.Error);
                }
            }
        }
    } else {
        if (window.innerWidth <= 1023)
            state.modalProfissionalVisivel = true;
        state.profissionalDesc === "" ? msg.InserirMensagem('Atenção', "Insira um profissional", TipoMensagem.Alert)
            : msg.InserirMensagem('Erro', "O profissional não possui horario marcado para este dia", TipoMensagem.Error);
    }
    const fim = performance.now();
    const tempoDecorrido = fim - inicio;
    state.aguarde = false;
    document.querySelector("html")?.classList.remove("overflow-hidden");
}

async function agendarCard(pObjeto: AgendaProfissional) {
    //@ts-expect-error: un
    state.agenda = pObjeto;
    state.estadoAgenda = "";
    state.pacienteCadastrado = true;
    if (!pObjeto.agendado) {
        state.nomePaciente = "";
        state.convenioDesc = "";
        state.convenio = Object() as Convenio;
        state.paciente = Object() as Paciente;
        state.comConvenio = false;
        state.lstProcedimentoAdd = [];
        state.lstProcedimentoAdd.pop();
        state.lstProcedimentoMostrar = [];
        state.lstProcedimentoMostrar.pop();
        state.agendaLancar.nomePaciente = "";
        state.agendaLancar.celular = "";
    } else {
        let data = await services.agendaProcedimento.ListarPorId(pObjeto.idAgenda);
        data.data.forEach((d: any, index: number) => {
            state.lstQtde.push(d.qtde);
        });
        data = await services.agenda.ListarPorId(pObjeto.idAgenda);
        // console.log(data);
        if (!data.erros) {
            state.paciente = data.data.paciente;
            if (data.data.paciente) {
                if (data.data.paciente.nomeSocial) {
                    state.nomePaciente = data.data.paciente.nomeSocial;
                } else {
                    state.nomePaciente = data.data.paciente.nome;
                }

            } else {
                state.nomePaciente = data.data.nomePaciente;
            }
            state.agendaLancar.celular = state.agenda.pacienteCelular;
            state.convenioDesc = data.data.convenio.descricao;
            state.convenio = data.data.convenio;
            state.comConvenio = true;
            if (state.paciente == null) {
                state.agendaLancar.nomePaciente = data.data.nomePaciente;
                // state.agendaLancar.celular = data.data.celular;
                state.pacienteCadastrado = false;
                state.lstAgendaPacienteCadastrado[pObjeto.item] = false;
            } else {
                state.pacienteCadastrado = true;
                state.lstAgendaPacienteCadastrado[pObjeto.item] = true;
            }
            iniciarListaAgenda(data.data.id);
        } else {
            const msg = mensagem();
            msg.InserirMensagem('Erro', data.erros.statusText, TipoMensagem.Error);
        }
    }
    state.agendando = true;
}

async function iniciarListaAgenda(pId: number) {
    state.lstProcedimentoAdd = [Object() as Procedimento];
    state.lstProcedimentoAdd.pop();
    state.lstProcedimentoMostrar = [];
    state.lstProcedimentoMostrar.pop();
    await services.agendaProcedimento.ListarPorId(pId)
        .then(resp => {
            resp.data.forEach((r: Record<string, any>) => {
                state.somaQtde += r.qtde;
                state.valorFinal += (r.procedimento.valor * r.qtde);
                state.lstProcedimentoMostrar.push(r.procedimento);
            });
        });
}

async function puxarDadosAtendimento(pObj: any) {
    let { data, erros } = await services.agenda.ListarPorId(pObj.idAgenda);
    state.agendaLancar = data;
    state.agenda = pObj;
    data.paciente ? (state.atendimento.paciente = data.paciente) : (state.nomePaciente = data.nomePaciente);
    state.convenioDesc = data.convenio.descricao;
    state.atendimento.convenio = data.convenio;
    state.atendimento.idProfExec = data.profissional.id;
    state.atendimento.idAgendamento = data.id;
    state.convenio = data.convenio;
    state.agenda.hora = pObj.hora;
}

async function puxarDadosAgenda(pObj: any) {
    const { data, erros } = await services.agenda.ListarPorId(pObj.idAgenda);
    state.agendaLancar = data;
    data.paciente ? (state.atendimento.paciente = data.paciente) : (state.nomePaciente = data.nomePaciente);
    state.convenioDesc = data.convenio.descricao;
    state.atendimento.convenio = data.convenio;
    state.atendimento.idProfExec = data.profissional.id;
    state.atendimento.idAgendamento = data.id;
    state.convenio = data.convenio;
    state.agenda.hora = pObj.hora;
}

async function visualizarAtend(pObj: any, tipo: string) {
    state.atendGerado = true;
    if (tipo == "Agenda")
        puxarDadosAgenda(pObj);
    if (tipo == "Atendimento")
        puxarDadosAtendimento(pObj);

    const { data, erros } = await services.agendaProcedimento.ListarPorId(pObj.idAgenda);
    if (!erros) {
        data.forEach((d: any, index: number) => {
            state.lstQtde.push(d.qtde);
        });
    } else {
        const msg = mensagem();
        msg.InserirMensagem('Erro', erros.statusText, TipoMensagem.Error);
    }
    fecharOpcoes();
    state.mostrarAtendimento = true;
    document.querySelector("html")?.classList.remove("overflow-hidden");

}

async function atendResult(pObj: any, pFechar: boolean, pGerar: boolean, pLstProc: any, pLstQtde: any, result: any) {
    // if (result != "cancel") {
    //     if (pGerar && moment(state.agendaLancar.dtAgenda).format('DD/MM/YYYY') == moment(new Date()).format('DD/MM/YYYY')) {
    //         let lstAux = pLstProc;
    //         const { data, erros } = await services.atendimento.SeqGenerator();

    //         if (state.atendimento.idProfSolic == 0) {
    //             state.atendimento.idProfSolic = null;
    //         }
    //         state.atendimento.id = data;
    //         state.atendimento.idAgendamento = state.agenda.idAgenda;
    //         await services.atendimento.Inserir(state.atendimento);

    //         state.atendProcedimento.idAtendimento = data;
    //         state.atendProcedimento.idConvenio = state.convenio.id;
    //         state.atendProcedimento.idProfExec = pObj.idProfExec;
    //         lstAux.forEach(async (l: any, index: number) => {
    //             state.atendProcedimento.item = index + 1;
    //             state.atendProcedimento.idProcedimento = l.id;
    //             state.atendProcedimento.vlrUnit = l.valor;
    //             state.atendProcedimento.qtde = 1;
    //             state.atendProcedimento.subTotal = state.atendProcedimento.qtde * l.valor;
    //             await services.atendProcedimento.Inserir(state.atendProcedimento);
    //         });
    //         alterarEstado('AT');
    //         //services.atendimento.AtendimentoProcedimentoInserir(pLstProcedimentoAdd);

    //     } else if (moment(state.agendaLancar.dtAgenda).format('DD/MM/YYYY') != moment(new Date()).format('DD/MM/YYYY')) {
    //         const msg = mensagem();
    //         msg.InserirMensagem('Erro', `O Atendimento só pode ser gerado se o dia da agenda for igual ao dia de hoje`, TipoMensagem.Alert);
    //     }
    // }
    state.mostrarAtendimento = false;
    if (state.telaPequena) {
        const { data, erros } = await services.agenda.ListarPorId(state.atendimento.idAgendamento);
        if (!erros) {
            abrirOpcoes(data);
        }
    }
}

function trocarExibicao(param: boolean) {
    state.exibicao = param;
}

function mostrarModalDiaAgenda() {
    if (window.innerWidth < 1024) {
        state.modalProfissionalVisivel = true;
    }
}

function modalDorapeResult() {
    state.modalProfissionalVisivel = false;
    document.querySelector("html")?.classList.remove("overflow-hidden");
}

// function retornaTema() {
//     let html = document.querySelector("html")?.getAttribute('data-theme');
//     if (html == "light") {
//         return false;
//     } else {
//         return true;
//     }
// }

function retornaBuscaProfDesabilitado() {
    // return (profissional.value.id > 0) ? true: false;
    return (usuario.value.login == "master" ||
        usuario.value.funcao == "Secretario" ||
        usuario.value.funcao == "Gerencial" ||
        usuario.value.funcao == "administracao") ? false : true;
}

async function abrirProntuario(historico: boolean) {
    const msg = mensagem();
    state.historico = historico;
    state.aguarde = true;
    let achou = false, sql = "";
    // sql += `SELECT A.ID, A.DT_AGENDA, A.HS_AGENDA, A.PACIENTE, PROF.NOME, P.DESCRICAO FROM AGENDAMENTO AS A 
    //         JOIN AGENDAMENTO_PROC AP ON AP.ID_AGENDAMENTO = A.ID
    //         JOIN PROCEDIMENTO P ON P.ID = A.ID_PROCEDIMENTO 
    //         JOIN PROFISSIONAL PROF ON PROF.ID = A.ID_PROFISSIONAL
    //         WHERE A.ID = ${state.agenda.idAgenda}`;
    let data = await services.agenda.ListarPorId(state.agenda.idAgenda);
    // console.log(state.agenda);
    // console.log(data);
    // console.log(state.paciente);
    if (!data.erros) {
        let dataPront = await services.pacienteProntuario.ListarPorIdPaciente(data.data.idPaciente);
        // console.log(dataPront);
        if (!dataPront.erros) {
            state.agendaLancar = data.data;
            if (historico) {
                state.lstProntuario = dataPront.data;
                state.prontuarioVisivel = true;
            } else {
                dataPront.data.forEach((pront: any) => {
                    if (pront.idAtendimento == state.agendaLancar.idAtendimento) {
                        achou = true;
                        state.prontuario = pront;
                    }
                });

                let label = "";

                (data.data.idAtendimento) ? label += "Atendimento" : label += "Agendamento";

                (achou == false) ? msg.InserirMensagem("Aviso", `Não foi possível encontrar um prontuário para este ${label}`, TipoMensagem.Alert) : state.prontuarioVisivel = true;
            }
            state.aguarde = false;
            fecharOpcoes();
        }
    } else {
        state.aguarde = false;
        msg.InserirMensagem("Erro", data.erros.statusText, TipoMensagem.Error);
    }
}

function fecharProntuario() {
    state.prontuarioVisivel = false;
    state.mostrarOpcoes = true;
}

function fecharOpcoes() {
    state.mostrarOpcoes = false;
}

function abrirOpcoes(pObj: any) {
    state.agenda = pObj;
    // state.prontuario = Object() as PacienteProntuario;
    // console.log(state.agenda);
    state.mostrarOpcoes = true;
}

function iniciar() {
    setTimeout(async () => {
        if (profissional.value.nome?.length > 0) {
            diasDisponiveis(profissional.value.id);
            const { data, erros } = await services.profissional.ListarPorId(profissional.value.id);
            if (!erros) {
                store.commit('setProfissional', data);
                state.profissional = data;
            }
            // console.log(await services.agenda.Listar(state.profissional.id, moment(state.diaAgenda).format("DD/MM/YYYY")));
            state.profissionalDesc = profissional.value.nome;
            verificarProximoDiaAgenda();
            // if (window.innerWidth >= 1024)
            //     gerar();
        }
        // console.log(window.innerWidth);
        if (window.innerWidth <= 1023) {
            state.modalProfissionalVisivel = true;
        }
    }, 1000);
    // }
    //@ts-expect-error:un
    state.diaAgenda = moment(new Date()).format("YYYY-MM-DD");

    setInterval(() => {
        window.innerWidth <= 1023 ? (state.telaCelular = true) : (state.telaCelular = false);
    }, 100);
}

function decimalToRGB(decimal: number) {
    // Certifique-se de que o valor decimal está na faixa de 0 a 65535
    if (decimal < 0) decimal = 0;
    if (decimal > 16777215) decimal = 16777215;

    const r = decimal & 255;
    const g = (decimal >> 8) & 255;
    const b = (decimal >> 16) & 255;

    return `rgb(${r}, ${g}, ${b})`;
}

onMounted(async () => {
    // console.log(router);
    router.afterEach(() => {
        if (localStorage.getItem('iniciar') == 'false')
            iniciar();
    });

    if (router.listening) {
        iniciar();
    }

    const { data, erros } = await services.AgendaSalaService.Listar();
    if (!erros) {
        state.lstAgendaSala = data;
    }

    setInterval(() => {
        props.tema == 'light' ? state.tema = false : state.tema = true;
        window.innerWidth <= 1400 ?
            (state.telaPequena = true, state.alturaModalPesq = 350)
            :
            (state.telaPequena = false, state.alturaModalPesq = 500);
    }, 100);
    // if (new Date().getUTCHours() >= 3) {
    //     let aux = new Date();
    //     if (String(new Date(`${aux.getMonth() + 1}/${aux.getDate() + 1}/${aux.getFullYear()}`)) == "Invalid Date") {
    //         if (String(new Date(`${aux.getMonth() + 2}/01/${aux.getFullYear()}`)) == "Invalid Date") {
    //             //@ts-expect-error:un
    //             state.diaAgenda = moment(`${aux.getMonth()}/01/${aux.getFullYear() + 1}`).format("YYYY-MM-DD");
    //             state.diaAgendaComponente = new Date(`${aux.getMonth()}/01/${aux.getFullYear() + 1}`);
    //         } else {
    //             //@ts-expect-error:un
    //             state.diaAgenda = moment(`${aux.getMonth() + 2}/01/${aux.getFullYear()}`).format("YYYY-MM-DD");
    //             state.diaAgendaComponente = new Date(`${aux.getMonth() + 2}/01/${aux.getFullYear()}`);
    //         }
    //     } else {
    //         //@ts-expect-error:un
    //         state.diaAgenda = moment(`${aux.getMonth() + 1}/${aux.getDate() + 1}/${aux.getFullYear()}`).format("YYYY-MM-DD");
    //         state.diaAgendaComponente = new Date(`${aux.getMonth() + 1}/${aux.getDate() + 1}/${aux.getFullYear()}`);
    //     }
    // } else {
    // }
    // state.lstAgendaProf.pop();
    // state.lstProcedimentoAdd.pop();
    // state.lstProcedimentoMostrar.pop();
    // state.lstAgendaPacienteCadastrado.pop();
    // state.comConvenio = false;

});

const showCalendar = ref(false);

const handleDayClick = (day: any) => {
    console.log("Dia selecionado:", day);
    showCalendar.value = false; // fecha o calendário após um dia ser clicado
};


return (_ctx: any,_cache: any) => {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", { class: "inline-block d-flex mb-0 w-100 justify-content-center" }, [
          _createElementVNode("p", {
            class: "form-label text-center fs-1 nav-link",
            onClick: mostrarModalDiaAgenda
          }, " Agenda ")
        ]),
        _createElementVNode("ul", {
          class: _normalizeClass(["align-items-center justify-content-center mainDiv mb-1 p-0", { 'dropdown-menu': state.telaCelular, 'd-flex': !state.telaCelular }])
        }, [
          _createElementVNode("label", _hoisted_3, [
            _createTextVNode("Profissional "),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "inputGroupFile02",
                disabled: "",
                placeholder: "Selecione o Profissional",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.profissionalDesc) = $event))
              }, null, 512), [
                [_vModelText, state.profissionalDesc]
              ]),
              _createElementVNode("button", {
                class: "btn btn-secondary",
                disabled: retornaBuscaProfDesabilitado(),
                onClick: pesquisaVisivelProfissional
              }, " Profissional ", 8, _hoisted_5)
            ])
          ]),
          _createElementVNode("label", _hoisted_6, [
            _createVNode(_component_VDatePicker, {
              modelValue: state.diaAgendaComponente,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.diaAgendaComponente) = $event)),
              "first-day-of-week": 1,
              "is-dark": state.tema,
              color: "gray",
              mode: "date",
              locale: "br",
              onInput: _cache[2] || (_cache[2] = ($event: any) => (gerar())),
              attributes: _unref(atributos)
            }, {
              default: _withCtx(({ togglePopover }) => [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: togglePopover,
                  style: {"width":"105px"}
                }, [
                  _createTextVNode(" Data "),
                  _hoisted_8,
                  _hoisted_9
                ], 8, _hoisted_7)
              ]),
              _: 1
            }, 8, ["modelValue", "is-dark", "attributes"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex marginBotoes", { 'ms-3': state.telaCelular }])
          }, [
            _createElementVNode("button", {
              class: "btn btn-info btn-gerar",
              style: {"width":"105px"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (gerar()))
            }, "Gerar")
          ], 2)
        ], 2),
        ((state.lstAgendaProf.length > 1 && state.lstAgendaProf.length == state.tamanhoLista))
          ? (_openBlock(), _createBlock(GridDorape, {
              key: 0,
              dados: state.lstAgendaProf,
              colunas: state.colunas,
              linhas: state.linhas,
              visualizarAtend: visualizarAtend,
              agendarCard: agendarCard,
              pacienteCadastrado: state.pacienteCadastrado,
              profissional: state.profissional,
              usarNomeSocial: state.nomeSocial,
              retornaPossuiPermissao: __props.retornaPossuiPermissao,
              onAbrirProntuario: abrirProntuario,
              onAbrirOpcoes: abrirOpcoes
            }, null, 8, ["dados", "colunas", "linhas", "pacienteCadastrado", "profissional", "usarNomeSocial", "retornaPossuiPermissao"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (state.prontuarioVisivel)
      ? (_openBlock(), _createBlock(ProntuarioComp, {
          key: 0,
          mostrarModal: state.prontuarioVisivel,
          retornaDataBR: __props.retornaDataBR,
          prontuario: state.prontuario,
          onFecharProntuario: fecharProntuario,
          agendaLancar: state.agendaLancar,
          historico: state.historico,
          lstProntuario: state.lstProntuario,
          config: _unref(config)
        }, null, 8, ["mostrarModal", "retornaDataBR", "prontuario", "agendaLancar", "historico", "lstProntuario", "config"]))
      : _createCommentVNode("", true),
    (state.ativarPesquisaProf)
      ? _withDirectives((_openBlock(), _createBlock(ModalPesqDorape, {
          key: 1,
          id: "pesqProfissional",
          title: "Profissional",
          tabela: "Profissional",
          SQL: "true",
          tabelaPorId: "Profissional",
          campoPorId: "id?id",
          listar: "/listar",
          nome: "Nome",
          codigo: "Id",
          height: `${state.alturaModalPesq}px`,
          width: "70%",
          hqlIdCliente: "t.IdCliente = :IdCliente and",
          visiblePesq: state.ativarPesquisaProf,
          data: state.profissional,
          pesquisaTabela: false,
          onModalResult: modalPesqResultProf,
          favorito: false,
          campoSelecionado: "nome"
        }, {
          header: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["height", "visiblePesq", "data"])), [
          [_vShow, state.ativarPesquisaProf]
        ])
      : _createCommentVNode("", true),
    (state.mostrarAtendimento)
      ? (_openBlock(), _createBlock(Atendimento, {
          key: 2,
          visiblePesq: state.mostrarAtendimento,
          atendimento: state.atendimento,
          tabelaConvenio: state.tabelaConvenio,
          convenio: state.convenio,
          nomePaciente: state.nomePaciente,
          height: "400px",
          width: "70%",
          visivel: true,
          agenda: state.agenda,
          agendaLancar: state.agendaLancar,
          atendGerado: state.atendGerado,
          lstQtde: state.lstQtde,
          onAtendResult: atendResult,
          agendando: state.agendando
        }, null, 8, ["visiblePesq", "atendimento", "tabelaConvenio", "convenio", "nomePaciente", "agenda", "agendaLancar", "atendGerado", "lstQtde", "agendando"]))
      : _createCommentVNode("", true),
    (state.modalProfissionalVisivel)
      ? (_openBlock(), _createBlock(ModalDorape, {
          key: 3,
          visible: state.modalProfissionalVisivel,
          title: "Agenda",
          usarFooter: false,
          usarModal: true,
          larguraMaxima: "50%",
          onModalResult: modalDorapeResult
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_11, [
              _createTextVNode("Profissional "),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "inputGroupFile02",
                  disabled: "",
                  placeholder: "Selecione o Profissional",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.profissionalDesc) = $event))
                }, null, 512), [
                  [_vModelText, state.profissionalDesc]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  disabled: retornaBuscaProfDesabilitado(),
                  onClick: pesquisaVisivelProfissional
                }, " Profissional ", 8, _hoisted_13)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, [
                _createElementVNode("input", {
                  class: "btn btn-outline border-0 fs-4",
                  disabled: "",
                  value: __props.retornaDataBR(state.diaAgendaComponente)
                }, null, 8, _hoisted_16),
                _createVNode(_component_VDatePicker, {
                  modelValue: state.diaAgendaComponente,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.diaAgendaComponente) = $event)),
                  "first-day-of-week": 1,
                  "is-dark": state.tema,
                  color: "gray",
                  mode: "date",
                  locale: "br",
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (gerar())),
                  attributes: _unref(atributos)
                }, null, 8, ["modelValue", "is-dark", "attributes"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "btn btn-info btn-gerar mt-3",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (gerar()))
              }, "Gerar")
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    (state.mostrarOpcoes)
      ? (_openBlock(), _createBlock(ModalDorape, {
          key: 4,
          visible: state.mostrarOpcoes,
          title: state.agenda.nomePaciente,
          usarFooter: false,
          usarModal: true,
          larguraMaxima: "90%",
          alturaMaxima: "90%",
          onModalResult: fecharOpcoes
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              (state.agenda.status == 'AO' || state.agenda.status == 'AG')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("button", {
                      class: "btn btn-nav d-flex align-items-center flex-column procedimento",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (visualizarAtend(state.agenda, 'Agenda')))
                    }, _hoisted_22)
                  ]))
                : _createCommentVNode("", true),
              (state.agenda.status == 'FE' || state.agenda.status == 'AT')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("button", {
                      class: "btn btn-nav d-flex align-items-center flex-column procedimento",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (visualizarAtend(state.agenda, 'Atendimento')))
                    }, _hoisted_26)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  class: "btn btn-nav d-flex align-items-center flex-column procedimento",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (abrirProntuario(false)))
                }, _hoisted_30),
                _createElementVNode("button", {
                  class: "btn btn-nav d-flex align-items-center flex-column procedimento",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (abrirProntuario(true)))
                }, _hoisted_33)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (state.aguarde)
      ? (_openBlock(), _createBlock(ModalDorape, {
          key: 5,
          title: "Aguarde",
          visible: state.aguarde,
          usarFooter: false,
          usarModal: true,
          larguraMaxima: '10%'
        }, {
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})